import React from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.css';

const DeadlineHistoryModal = ({ 
  show,
  onHide,
  deadlines,
  loading,
  taskId
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
    >
      <Modal.Header className="modal-customheader" closeButton>
        <Modal.Title className="custom-modaltitle">
          Deadline History for Task {taskId}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="custommodal-body">
        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" variant="primary" />
            <p className="mt-2">Loading deadline history...</p>
          </div>
        ) : deadlines.length > 0 ? (
          <div className="timeline">
            {deadlines.map((deadline, index) => (
              <div key={index} className="timeline-item">
                <div className="timeline-marker"></div>
                <div className="timeline-content">
                  
                  <div className="d-flex justify-content-between">
                    <h6 className="mb-1">
                      {/* Old → New deadline */}
                      {deadline.oldDeadline 
                        ? new Date(deadline.oldDeadline).toLocaleDateString('en-GB', {
                            day: 'numeric',
                            month: 'short',
                            year: 'numeric'
                          })
                        : 'N/A'}
                      {" → "}
                      {deadline.newDeadline 
                        ? new Date(deadline.newDeadline).toLocaleDateString('en-GB', {
                            day: 'numeric',
                            month: 'short',
                            year: 'numeric'
                          })
                        : 'N/A'}
                    </h6>

                    <small className="text-muted">
                      {new Date(deadline.changeDate).toLocaleString('en-GB', {
                        day: 'numeric',
                        month: 'short',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                    </small>
                  </div>

                  <p className="mb-1">Changed by: {deadline.changedBy}</p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-4">
            <i className="bi bi-calendar-x fs-1 text-muted no-deadline-calendar" />
            <p className="mt-2">No deadline history available</p>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default DeadlineHistoryModal;
